/**
 * Fidelity (Mockups 17/18/19/20 „PublicChrome") — die gemeinsame Marken-Hülle
 * der öffentlichen, anonymen Seiten (geteilte Board/Liste/Notiz + Formular).
 * Diese Seiten laufen AUSSERHALB des RyfeProvider (kein `useRyfe`), darum holt
 * die Hülle das Branding selbst über den öffentlichen `/api/branding`-Endpunkt.
 * Kopf: Logo + Produktname · optionaler Titel · optionale Aktionen · Badge.
 * Fuß (nur `doc`): eine kurze Bildunterschrift (z. B. „anonym und eingefroren").
 */

import { useEffect, useState } from "react";

import { ryfeApi } from "../api";

import "./ryfe.scss";

import type { ReactNode } from "react";
import type { Branding } from "../api";

export const PublicChrome = ({
  title,
  badge,
  footer,
  actions,
  variant = "doc",
  children,
}: {
  title?: string;
  badge?: string;
  footer?: string;
  actions?: ReactNode;
  // "doc" = zentriertes Dokument (Liste/Notiz/Formular); "board" = vollflächige
  // Leinwand (die Hülle wird zur fixierten Kopf+Body-Spalte).
  variant?: "doc" | "board";
  children: ReactNode;
}) => {
  const [branding, setBranding] = useState<Branding | null>(null);

  useEffect(() => {
    let cancelled = false;
    ryfeApi
      .getBranding()
      .then((b) => {
        if (!cancelled) {
          setBranding(b);
        }
      })
      .catch(() => {
        /* Branding ist optional — Fallback ist der Produktname unten. */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className={`ryfe-public${
        variant === "board" ? " ryfe-public--board" : ""
      }`}
    >
      <header className="ryfe-public__bar">
        <span className="ryfe-public__brand">
          {branding?.logo && (
            <img
              className="ryfe-public__logo"
              src={branding.logo}
              alt=""
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
          )}
          {branding?.productName ?? "RYFE — Whiteboard"}
        </span>
        {title && <span className="ryfe-public__title">{title}</span>}
        <span className="ryfe-topbar__spacer" />
        {actions}
        {badge && (
          <span className="ryfe-badge ryfe-public__badge">{badge}</span>
        )}
      </header>
      <div className="ryfe-public__body">{children}</div>
      {footer && variant === "doc" && (
        <footer className="ryfe-public__foot">{footer}</footer>
      )}
    </div>
  );
};
